import React from 'react';
import { Icon } from '../Icon';
import './styles.scss';

interface ScrollToBottomButtonProps {
  count: number;
  onClick: () => void;
}

export const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  count,
  onClick,
}) => {
  return (
    <button
      className="peptalk-scroll-to-bottom"
      onClick={onClick}
      aria-label={`${count} new message${count === 1 ? '' : 's'}, scroll to bottom`}
      type="button"
    >
      <span className="peptalk-scroll-to-bottom-count">{count}</span>
      <Icon name="ChevronDown" color="currentColor" width="10" height="5" />
    </button>
  );
};
